import { render, staticRenderFns } from "./paibanHistory.vue?vue&type=template&id=a1eb56ea&scoped=true&"
import script from "./paibanHistory.vue?vue&type=script&lang=js&"
export * from "./paibanHistory.vue?vue&type=script&lang=js&"
import style0 from "./paibanHistory.vue?vue&type=style&index=0&id=a1eb56ea&prod&scoped=true&lang=less&"
import style1 from "./paibanHistory.vue?vue&type=style&index=1&id=a1eb56ea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eb56ea",
  null
  
)

export default component.exports